import { parseDate, useSecuritiesContext } from '@talos/kyoko';
import { isSameDay } from 'date-fns';
import { useCallback } from 'react';

/**
 * Client-side expiry filter shared by desktop and mobile Positions blotters
 * (Derivatives + Unified). Resolves expiration from securities context until
 * the Position entity carries expiration directly.
 */
export function usePositionsExpiryFilter<TRow>(
  assetGetter: (row: TRow) => string,
  expiries: string[] | undefined
): (row: TRow) => boolean {
  const { securitiesBySymbol } = useSecuritiesContext();
  return useCallback(
    (row: TRow) => {
      if (expiries == null) {
        return true;
      }
      const expiration = securitiesBySymbol.get(assetGetter(row))?.Expiration;
      if (expiration == null) {
        return false;
      }
      const expirationDate = parseDate(expiration);
      return expiries.some(expiryString => isSameDay(expirationDate, parseDate(expiryString)));
    },
    [securitiesBySymbol, expiries, assetGetter]
  );
}
